// src/components/BookingFlow.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { AnimatePresence } from "framer-motion";
import {
  BookingProvider,
  useBookingState,
  useBookingDispatch,
} from "./BookingContext";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import HeaderDriverCard from "./HeaderDriverCard";
import RideTypeSelector from "./RideTypeSelector";
import RideDetailsForm from "./RideDetailsForm";
import ReviewBooking from "./ReviewBooking";
import ConfirmationScreen from "./ConfirmationScreen";
import "./BookingFlow.css";

export default function BookingFlow() {
  return (
    <BookingProvider>
      <BookingContent />
    </BookingProvider>
  );
}

function BookingContent() {
  const {
    step,
    rideType,
    terminal,
    pickup,
    dropOff,
    when,
    dateTime,
    name,
    phone,
  } = useBookingState();

  const dispatch = useBookingDispatch();
  const location = useLocation();
const navigate = useNavigate();
  const [driverData, setDriverData] = useState(null);
  const [vehicleData, setVehicleData] = useState(null)
   const [noVehicleDialogOpen, setNoVehicleDialogOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const driverID = params.get('id');
    //params.get('id');
    //"68665f0b8398baf02c336822"
    //params.get('id');
    //params.get('id');
    //67bd5599ec64bd45254f206e
    //"68380952eaec95ae3d65d289"
    // params.get('id')?
    
    // nvm use 20.18.0
    //npm run build
    //firebase deploy --only hosting

    if (driverID) {
      dispatch({ type: "SET_POSTER_ID", payload: driverID });
      axios
        .post("https://api.taxitribe.com/api/drivers/getDriverProfile", {
          driverId: driverID,
        })
        .then((response) => {
          if (response.data.success) {
            console.log(response.data.result);
            setDriverData(response.data.result.driverDetails);
            setVehicleData(response.data.result.vehicleDetails)
            if (!response.data.result.driverDetails.vehicleRegNo) {
              setNoVehicleDialogOpen(true);
          }
          } else {
            console.error(
              "Failed to fetch driver data:",
              response.data.message
            );
          }
        })
        .catch((err) => {
          console.error("Error fetching driver data:", err);
        });
    }
  }, [location.search]);

  // dummy fare/distance, replace with real calc
  //const distance  = '20 kms'
  const passenger = {
    name,
    avatarUrl: "https://avatar.iran.liara.run/public/13",
  };
  const fare = { amount: 700, gst: 10, total: 710 };

  const goBack = () => {
    if (step === "details") {
      dispatch({ type: "EDIT_STEP", payload: "rideType" });
    } else if (step === "review") {
      dispatch({ type: "EDIT_STEP", payload: "details" });
    }
    // no back from confirmation or rideType
  };

  return (
    <div className="bf-wrapper">

<Dialog open={noVehicleDialogOpen} onClose={() => navigate(-1)}>
        <DialogTitle>No Vehicle Assigned</DialogTitle>
        <DialogContent>
         Sorry, this driver currently has no active vehicle on record. You can’t proceed with booking at the moment.
        </DialogContent>
        {/* <DialogActions>
          <Button
            onClick={() => navigate(-1)}
            variant="contained"
          >
            Go Back
          </Button>
        </DialogActions> */}
      </Dialog>

      {step !== "rideType" && step !== "confirmation" && (
        <IconButton className="bf-back" onClick={goBack} size="large">
          <ArrowBackIcon />
        </IconButton>
      )}
      {step !== "details" &&
        step !== "review" &&
        step !== "confirmation" &&
        driverData && <HeaderDriverCard driver={driverData} vehicle={vehicleData} />}

      <AnimatePresence exitBeforeEnter>
        {step === "rideType" && <RideTypeSelector key="rideType" />}
        {step === "details" && (
          <RideDetailsForm
            key="details"
            onReview={() => dispatch({ type: "TO_REVIEW" })}
          />
        )}
        {step === "review" && (
          <ReviewBooking
            key="review"
            rideType={rideType}
            terminal={terminal}
            pickup={pickup}
            dropOff={dropOff}
            dateTime={dateTime}
            passenger={passenger}
            driver={driverData}
            onEdit={(section) =>
              dispatch({ type: "EDIT_STEP", payload: section })
            }
            onConfirm={() => dispatch({ type: "TO_CONFIRMATION" })}
          />
        )}
        {step === "confirmation" && <ConfirmationScreen key="confirmation" />}
      </AnimatePresence>
    </div>
  );
}

